import React from 'react';
import PropTypes from 'prop-types';
import { Wrapper, Line, Progress, Steps, Step } from './DiagnosisStep.style';

class DiagnosisStep extends React.Component {
  state = {};

  getProgressWidth = (pageNumber, maxNumber) => {
    const rate = parseInt((pageNumber - 1) / (maxNumber - 1) * 100, 10);
    return `${rate}%`;
  };

  render() {
    const { pageNumber, maxNumber } = this.props;
    const steps = [];

    for (let i = 0; i < maxNumber; i += 1) {
      const number = i + 1;
      steps.push(
        <Step className={pageNumber >= number ? 'active' : ''} key={i}>
          {number}
        </Step>
      );
    }

    return (
      <Wrapper>
        <Line />
        <Progress style={{ width: this.getProgressWidth(pageNumber, maxNumber) }} />
        <Steps>{steps}</Steps>
      </Wrapper>
    );
  }
}

DiagnosisStep.defaultProps = {};
DiagnosisStep.propTypes = {
  pageNumber: PropTypes.number.isRequired,
  maxNumber: PropTypes.number.isRequired,
};
export default DiagnosisStep;



// WEBPACK FOOTER //
// ./src/pages/SalonConsultationPage/SublimicDiagnosisPage/DiagnosisStep/DiagnosisStep.js